import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import firebase from 'firebase/app'
import 'firebase/firestore'

import UnitList from './components/units/UnitList'
import StationList from './components/station/StationList'
import Report from "./components/Report"
import Schedule from "./components/schedule/Schedule"

Date.prototype.getWeekNumber = function() {
  var d = new Date(
      Date.UTC(this.getFullYear(), this.getMonth(), this.getDate())
  )
  var dayNum = d.getUTCDay() || 7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum)
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7)
};

Date.prototype.getMonday = function() {
  const day = this.getDay()
  const diff = this.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
  return new Date(this.setDate(diff))
}

Date.prototype.addDays = function(days) {
  return new Date(this.setDate(this.getDate() + days))
}

Date.prototype.humanDate = function() {
  const options = { year: 'numeric', month: "long", day: "numeric" }
  return this.toLocaleDateString("sv-SE", options)
}

Date.prototype.humanDateTime = function() {
  const options = { year: 'numeric', month: "long", day: "numeric", hour: 'numeric', minute: 'numeric' }
  return this.toLocaleDateString("sv-SE", options)
}

Vue.config.productionTip = false

Vue.use(VueRouter)
const routes = [
    { path: '/', component: Schedule },
    { path: '/schedule', component: Schedule },
    { path: '/units', component: UnitList },
    { path: '/reports', component: Report },

    // SysAdmin
    { path: '/stations', component: StationList },
]
const router = new VueRouter({
  routes,
  mode: 'history'
})





const globalState = Vue.observable({
    stationId: '',
})

Object.defineProperty(Vue.prototype, '$stationId', {
    get () {
        return globalState.stationId
    },

    set (value) {
        globalState.stationId = value
    }
})







new Vue({
    template: '<App />',
    created () {
        const firebaseConfig = {
            apiKey: "AIzaSyC8nAXBwHUl-o6jEKTt6Ub93mLD2gnuZVI",
            authDomain: "sidon-stage.firebaseapp.com",
            databaseURL: "https://sidon-stage.firebaseio.com",
            projectId: "sidon-stage",
            storageBucket: "sidon-stage.appspot.com",
            messagingSenderId: "372176329974",
            appId: "1:372176329974:web:bab52c4a5cd8888cc2e0d7",
            measurementId: "G-G45JBSX8LX"
        }
        window.fb = firebase.initializeApp(firebaseConfig)
        firebase.analytics()
        window.db = firebase.firestore()
        window.db.enablePersistence()
        window.stationId = null
    },
    el: '#app',
    vuetify,
    router,
    render: h => h(App),
})
